/**
 * categoryIcons — the category → icon identity map (UX-13 S0; promoted
 * from peace-hub-port/CategoryTiles so IdentityChip and the tiles share
 * one source). Identity DATA lives beside CATEGORY_TILE_COLORS in
 * uiCategoryLabels; this module carries the icon half of the pair.
 */

import {
  Briefcase,
  Building,
  Building2,
  Car,
  HeartPulse,
  House,
  Landmark,
  Star,
  Stethoscope,
  type LucideIcon,
} from 'lucide-react';

export const CATEGORY_ICON: Record<string, LucideIcon> = {
  'Medical Practice': Stethoscope,
  'Activities & Programs': Star,
  'Government and Non-Profit': Landmark,
  'Care Facility / Housing': Building2,
  'Hospital & Health System': Building,
  'Professional Services': Briefcase,
  'Home & Personal Services': House,
  'Home Health & Hospice': HeartPulse,
  'Transportation': Car,
};
